/**
 * The attachment's download name. The backend's `Content-Disposition` is the
 * path's own basename (`DownloadFile` sets it from `filepath.Base`), so the
 * old panel's header parse is reproduced without the header round trip —
 * basename first, the stored `file_name` next, the "File" label last.
 */
export function broadcastDownloadName(
  filePath: string,
  fileName: string | null,
  fallback: string,
): string {
  const base = filePath.split('/').pop();
  if (base) return base;
  if (fileName) return fileName;
  return fallback;
}
